var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuMedicinesDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1148_11282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.55 21.55V2.45H2.45V21.55H21.55Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1148_11282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6731 11.9496H15.4962C15.7565 11.9496 15.9703 12.1633 15.9703 12.4235V13.2939H16.841C17.1024 13.2939 17.3163 13.5075 17.3163 13.7689V14.5916C17.3163 14.8517 17.1024 15.0655 16.841 15.0655H15.9703V15.9358C15.9703 16.1971 15.7565 16.4108 15.4962 16.4108H14.6731C14.4117 16.4108 14.1979 16.1971 14.1979 15.9358V15.0655H13.3272C13.0668 15.0655 12.853 14.8517 12.853 14.5916V13.7689C12.853 13.5075 13.0668 13.2939 13.3272 13.2939H14.1979V12.4235C14.1979 12.1633 14.4117 11.9496 14.6731 11.9496Z",
    stroke: "#667085",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 4.52767H17.6673C17.8977 4.52767 18.0861 4.33943 18.0861 4.10912V2.8092C18.0861 2.57888 17.8977 2.39064 17.6673 2.39064H12.5007C12.2702 2.39064 12.0819 2.57888 12.0819 2.8092V4.10912C12.0819 4.33943 12.2702 4.52767 12.5007 4.52767Z",
    stroke: "#667085",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59375 21.6094H10.1456C11.4561 21.6094 12.5284 20.5375 12.5284 19.2277C12.5284 17.9178 11.4561 16.8459 10.1456 16.8459H5.59375C4.28328 16.8459 3.21094 17.9178 3.21094 19.2277C3.21094 20.5375 4.28328 21.6094 5.59375 21.6094Z",
    stroke: "#667085",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2165 4.52764V5.85858C19.3058 6.70674 20.7891 8.76073 20.7891 11.1446V19.8865C20.7891 20.7479 20.0834 21.4522 19.2227 21.4522H10.993M9.38013 16.8459V11.1446C9.38013 8.76073 10.8634 6.70674 12.9527 5.85858V4.52764",
    stroke: "#667085",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.789 18.1801H12.2835M16.6703 10.2068L20.707 10.1802M9.45319 10.2344L13.4821 10.2145",
    stroke: "#667085",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87024 16.8459V21.6094",
    stroke: "#667085",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0718 10.2068H15.0788",
    stroke: "#667085",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMedicinesDefault);
export default __webpack_public_path__ + "static/media/icon-menu-medicines-default.73a8eeda.svg";
export { ForwardRef as ReactComponent };